import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";

const MultipleSaveSmartFilterFields = ({ filters, selectedFilterId, onSelectFilter }) => (
  <>
    <p className="tw-m-0 tw-text-14d tw-leading-[20px] tw-text-gray-75">
      Your current filters match multiple Smart Filters. Please choose which one you want to use to generate
      the recipient list.
    </p>
    <div className="tw-flex tw-flex-col tw-gap-[8px]">
      <p className="tw-m-0 tw-text-14d tw-font-semibold tw-leading-[20px] tw-text-gray-75">
        Select Smart Filter:
      </p>
      {filters.map((filter) => (
        <RadioButton
          key={filter.id}
          name="smart-filter"
          value={String(filter.id)}
          label={filter.name}
          checked={String(selectedFilterId) === String(filter.id)}
          onChange={() => onSelectFilter(filter.id)}
        />
      ))}
    </div>
  </>
);

MultipleSaveSmartFilterFields.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  selectedFilterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectFilter: PropTypes.func,
};

MultipleSaveSmartFilterFields.defaultProps = {
  filters: [],
  selectedFilterId: null,
  onSelectFilter: () => {},
};

export default MultipleSaveSmartFilterFields;
